import { useContext } from 'react'
import { Sidekick } from 'contexts/SidekickProvider'

/**
 * The useSidekick hook is used to set up functionality for using the virtual
 * assistant within the app. The virtual assistant is loaded into an iframe and
 * so communication between the app and the assistant will be via message
 * events.
 *
 * This hook is now a simple wrapper around the SidekickProvider context to
 * maintain API consistency throughout the app.
 *
 * Note: This hook returns all properties from SidekickProvider's contextValue,
 * including isOpen, openSidekick, closeSidekick, setConfig, etc. See
 * SidekickProvider.js for the complete list of available properties.
 */
export const useSidekick = () => {
  const context = useContext(Sidekick)
  if (!context) {
    throw new Error('useSidekick must be used within SidekickProvider')
  }
  return context
}
